"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavDropdown = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _react = _interopRequireDefault(require("react"));
var _CategoryList = require("../category-list/CategoryList");
var _navDropdownModule = _interopRequireDefault(require("./nav-dropdown.module.scss"));
var _DropdownIcon = require("../dropdown-icon/DropdownIcon");
var _NavLink = require("../nav-link/NavLink");
var _classnames = _interopRequireDefault(require("classnames"));
var NavDropdown = function NavDropdown(_ref) {
  var children = _ref.children,
    items = _ref.items,
    visible = _ref.visible,
    onClick = _ref.onClick,
    active = _ref.active;
  if (items.length === 1) {
    return /*#__PURE__*/_react.default.createElement(_NavLink.NavLink, {
      href: items[0].href,
      active: active
    }, items[0].title);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    onClick: onClick,
    className: (0, _classnames.default)(_navDropdownModule.default['nav-dropdown'], (0, _defineProperty2.default)({}, _navDropdownModule.default['nav-dropdown--active'], active))
  }, children), /*#__PURE__*/_react.default.createElement(_DropdownIcon.DropdownIcon, null), visible && /*#__PURE__*/_react.default.createElement(_CategoryList.CategoryList, {
    items: items
  }));
};
exports.NavDropdown = NavDropdown;